export { SORT_TYPES } from './sortTypes';

export const GROUP_BY_CODE = 'code';
export const GROUP_BY_CODE_EVENT = 'code_event';

export const GENERAL_LEDGER_COLUMNS = [
  { id: 'general_ledger_code', label: 'GL Code', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'account', label: 'Account', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'source', label: 'Source', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'amount', label: 'Amount', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'currency' },
];

export const GENERAL_LEDGER_EVENT_COLUMNS = [
  { id: 'general_ledger_code', label: 'GL Code', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'account', label: 'Account', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'source', label: 'Source', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'event_name', label: 'Event', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'event_date', label: 'Event Date', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'amount', label: 'Amount', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'currency' },
];

export const buildGeneralLedgerColumns = () => GENERAL_LEDGER_COLUMNS;

export const columnsForGroupBy = (groupBy) =>
  (groupBy === GROUP_BY_CODE_EVENT ? GENERAL_LEDGER_EVENT_COLUMNS : GENERAL_LEDGER_COLUMNS);

export const getDefaultVisibleColumns = () =>
  GENERAL_LEDGER_EVENT_COLUMNS.filter(c => c.defaultVisible);

export const getDefaultHiddenColumns = () =>
  GENERAL_LEDGER_EVENT_COLUMNS.filter(c => !c.defaultVisible && !c.alwaysVisible);
